import { useState } from "react";

export type FaqItem = { q: string; a: string };

/**
 * Accessible FAQ disclosure list.
 * Caller is responsible for emitting the FAQPage JSON-LD via head().scripts
 * using faqPageSchema(), keeps SSR HTML clean.
 */
export function SeoFaq({
  items,
  heading = "Frequently asked questions",
  className = "",
}: {
  items: FaqItem[];
  heading?: string;
  className?: string;
}) {
  if (!items?.length) return null;
  return (
    <section className={`card-surface rounded-md p-6 sm:p-8 ${className}`}>
      <h2 className="font-display text-[clamp(1.4rem,2.4vw,1.8rem)] font-semibold tracking-[-0.03em] leading-[1.15] text-foreground mb-4">
        {heading}
      </h2>
      <div className="divide-y divide-border/60">
        {items.map((it, i) => (
          <FaqRow key={i} item={it} />
        ))}
      </div>
    </section>
  );
}

function FaqRow({ item }: { item: FaqItem }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="py-3.5">
      <button
        type="button"
        aria-expanded={open}
        onClick={() => setOpen((v) => !v)}
        className="flex w-full items-center justify-between text-left text-[15px] font-medium text-foreground hover:text-primary transition-colors"
      >
        <span>{item.q}</span>
        <span aria-hidden className="ml-3 text-xl leading-none text-muted-foreground">
          {open ? "−" : "+"}
        </span>
      </button>
      {open && (
        <p className="mt-2 text-[14px] leading-relaxed text-muted-foreground">{item.a}</p>
      )}
    </div>
  );
}
